// extracted by mini-css-extract-plugin
export default {"buddhism":"index_buddhism_ITply"};